import { gettext } from "web/script/modules/django-i18n";
import React from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { ReduxStoreState } from "web/redux/store";
import LoadingSpinner from "web/react/components/loading-spinner/loading-spinner";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import { hideSeoContent } from "web/redux/ducks/feed-seo-content";
import analytics from "web/script/analytics/analytics";
import history from "web/script/utils/history";
import globals from "web/script/modules/globals";
import { setLoading, FeedsShowPreviousSlice } from "web/redux/ducks/feed-show-previous";
import styles from "./feeds-show-previous.css";

interface FeedShowPreviousProps {
    initialButtonUrl: string;
}

function feedShowPreviousState(state: ReduxStoreState): FeedsShowPreviousSlice {
    return {
        isLoading: state.feedShowPreviousReducer.isLoading,
        buttonUrl: state.feedShowPreviousReducer.buttonUrl,
    };
}

export function FeedsShowPrevious({ initialButtonUrl }: FeedShowPreviousProps): JSX.Element | null {
    const feedState = useReduxSelector(feedShowPreviousState);
    const dispatch = useDispatch();
    let { isLoading, buttonUrl } = feedState;

    // Initial values for server-side rendering
    if (buttonUrl === null) {
        buttonUrl = initialButtonUrl;
    }

    function showPrevious(): void {
        const pageViewId = history.getCurrentState().pageViewId;
        history.pushState(new URL(buttonUrl || "", globals.window.location.href), {
            saveScrollPosition: false,
            data: { pageViewId },
        });
        dispatch(hideSeoContent());
        dispatch(setLoading(true));
    }

    function onClickShowPrevious(event: React.MouseEvent<HTMLAnchorElement>): void {
        event.preventDefault();
        analytics.event("feeds_show_previous", "click_show_previous_button", "click");
        showPrevious();
    }

    let loadingHtml: JSX.Element | null = null;
    if (isLoading === true) {
        loadingHtml = <LoadingSpinner />;
    }

    return (
        <>
            {buttonUrl && (
                <div className={styles.wrapper}>
                    <PrimaryButton
                        className={styles.showPreviousButton}
                        href={buttonUrl}
                        fullHeight={false}
                        fullWidth={false}
                        openInNewTab={false}
                        disabled={false}
                        onClick={onClickShowPrevious}
                    >
                        <div className={styles.buttonText}>{gettext("general.show_previous")}</div>
                        <div className={styles.loadingWrapper}>{loadingHtml}</div>
                    </PrimaryButton>
                </div>
            )}
        </>
    );
}

export default FeedsShowPrevious;
